export enum NavPosition {
    TOP = 'top',
    BOTTOM = 'bottom',
    NONE = 'none',
}
